import React from "react";
import KeywordsTag from './KeywordsTag';

const Nature = ({ yearsIsVisible, monthsIsVisible, keywordsIsVisible }) => (
    <KeywordsTag
        tagId="naturePublic"
        handwritingSrc="../../content/handwriting/nature.png"
        handwritingAlt="nature"
        yearsIsVisible={yearsIsVisible}
        monthsIsVisible={monthsIsVisible}
        keywordsIsVisible={keywordsIsVisible}
    />
);

export default Nature;